export enum VisibilityMediaType {
  ShowOnlyValidMedia = 0,
  ShowAllMedia = 1,
  NoShowMedia = 2
}

